import { NgModule } from '@angular/core';
import {
	ActivitySourceDialogComponent
} from '@go-modules/components/dialogs/activity-source-dialog/activity-source-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		A11yModule
	],
	declarations: [
		ActivitySourceDialogComponent
	],
	exports: [
		ActivitySourceDialogComponent
	]
})
export class ActivitySourceDialogModule {}
